var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 393,
    viewBox: "0 0 361 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.928 263.525C258.492 263.525 258.049 263.444 257.617 263.277L93.9381 198.781C89.6999 197.11 86.3676 193.891 84.5517 189.717C82.7359 185.542 82.6581 180.909 84.3262 176.672L121.11 83.3902C122.782 79.1534 126.001 75.8223 130.177 74.0071C134.353 72.1919 138.988 72.1142 143.227 73.7817L294.37 133.337C303.118 136.785 307.431 146.704 303.982 155.45L278.385 220.365C277.662 222.204 275.581 223.109 273.742 222.382C271.903 221.66 271.001 219.58 271.724 217.742L297.321 152.826C298.289 150.37 298.242 147.68 297.193 145.258C296.139 142.837 294.206 140.967 291.745 139.999L140.602 80.44C138.145 79.4721 135.454 79.5188 133.031 80.5721C130.609 81.6255 128.739 83.5573 127.77 86.0177L90.9869 179.292C90.0187 181.749 90.0654 184.438 91.1191 186.86C92.1728 189.281 94.1053 191.151 96.5667 192.119L260.246 256.615C262.085 257.338 262.987 259.417 262.264 261.256C261.704 262.667 260.355 263.525 258.928 263.525Z",
    fill: "url(#paint0_linear_4757_207265)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.007 294.594C289.089 294.594 288.175 294.244 287.476 293.544L236.072 242.159C227.331 233.421 227.331 219.199 236.072 210.461C244.813 201.724 259.04 201.724 267.781 210.461L308.123 250.788C309.522 252.187 309.522 254.453 308.123 255.849C306.723 257.248 304.46 257.248 303.06 255.849L262.719 215.522C256.769 209.575 247.084 209.575 241.134 215.522C235.185 221.469 235.185 231.151 241.134 237.098L292.538 288.483C293.938 289.883 293.938 292.149 292.538 293.544C291.838 294.244 290.924 294.594 290.007 294.594Z",
    fill: "url(#paint1_linear_4757_207265)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.153 292.957C249.689 292.957 246.213 292.374 242.896 291.193L192.616 273.255C183.342 269.947 177.424 260.781 178.229 250.971L179.753 232.356C179.917 230.386 181.643 228.924 183.615 229.084C185.586 229.247 187.052 230.973 186.889 232.943L185.364 251.558C184.824 258.146 188.798 264.295 195.023 266.519L245.303 284.457C252.197 286.917 259.97 285.988 266.09 281.969L275.682 275.672C277.335 274.588 279.555 275.046 280.64 276.698C281.725 278.35 281.266 280.57 279.613 281.654L270.021 287.951C264.978 291.255 259.079 292.957 253.153 292.957Z",
    fill: "url(#paint2_linear_4757_207265)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.393 365.814C353.604 365.814 352.061 364.477 351.843 362.658L337.452 241.829C336.511 233.923 333.548 226.332 328.879 219.883C324.209 213.431 317.925 208.246 310.708 204.88L285.112 192.947C283.319 192.111 282.545 189.981 283.381 188.189C284.217 186.398 286.348 185.624 288.137 186.46L313.733 198.393C322.055 202.272 329.298 208.254 334.68 215.689C340.061 223.125 343.479 231.874 344.564 240.985L358.955 361.81C359.188 363.773 357.788 365.553 355.825 365.787C355.677 365.806 355.537 365.814 355.393 365.814Z",
    fill: "url(#paint3_linear_4757_207265)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.264 342.473C255.556 342.473 254.895 342.426 254.273 342.329L216.031 336.456C205.786 334.882 197.776 326.599 196.551 316.31L195.147 304.506C189.408 301.167 185.306 295.461 184.073 288.631C184.038 288.445 184.023 288.258 184.019 288.072L183.548 265.745C183.505 263.771 185.076 262.134 187.052 262.091C189.015 262.037 190.664 263.619 190.707 265.594L191.169 287.621C192.433 294.011 197.352 298.936 203.764 300.199L249.914 309.302C253.931 310.095 258.045 309.663 261.812 308.058L283.062 298.99C283.995 298.59 285.053 298.609 285.974 299.037C286.896 299.464 287.592 300.261 287.891 301.233L291.064 311.545C291.834 314.052 291.889 317.36 291.232 321.662C290.345 327.454 286.394 332.429 280.924 334.649C271.988 338.271 266.323 340.444 264.087 341.109C261.011 342.022 258.43 342.473 256.264 342.473ZM202.687 307.289L203.659 315.467C204.506 322.576 210.039 328.297 217.116 329.386L255.358 335.259C256.167 335.383 258.115 335.418 262.042 334.252C264.002 333.669 269.749 331.457 278.229 328.021C281.375 326.746 283.645 323.897 284.151 320.586C284.785 316.431 284.466 314.456 284.217 313.651L282.214 307.141L264.624 314.646C259.53 316.819 253.962 317.402 248.526 316.333L202.687 307.289Z",
    fill: "url(#paint4_linear_4757_207265)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.325 361.414C275.142 361.414 274.959 361.398 274.772 361.371L249.032 357.391C238.634 355.781 230.302 348.14 227.809 337.921C227.339 336.001 228.517 334.065 230.438 333.595C232.359 333.125 234.295 334.302 234.766 336.222C236.57 343.619 242.601 349.15 250.128 350.313L275.869 354.293C277.821 354.596 279.162 356.423 278.859 358.378C278.583 360.146 277.059 361.414 275.325 361.414Z",
    fill: "url(#paint5_linear_4757_207265)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.462 305.862C282.794 305.862 281.301 304.688 280.955 302.99L277.257 284.647C276.868 282.712 278.121 280.823 280.061 280.434C282.001 280.041 283.887 281.297 284.276 283.236L287.974 301.579C288.362 303.514 287.11 305.403 285.17 305.792C284.933 305.839 284.696 305.862 284.462 305.862Z",
    fill: "url(#paint6_linear_4757_207265)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.191 143.863C175.262 143.863 173.334 143.501 171.483 142.778C167.587 141.255 164.515 138.308 162.839 134.476C161.159 130.643 161.078 126.391 162.598 122.496C164.122 118.602 167.07 115.531 170.904 113.856C174.738 112.177 178.991 112.095 182.887 113.615C186.784 115.139 189.855 118.085 191.531 121.917C193.211 125.75 193.297 130.002 191.772 133.897C190.248 137.792 187.301 140.862 183.467 142.537C181.457 143.424 179.326 143.863 177.191 143.863ZM177.187 119.694C176.028 119.694 174.874 119.935 173.777 120.413C171.697 121.323 170.095 122.99 169.267 125.105C168.438 127.219 168.485 129.528 169.395 131.607C170.305 133.687 171.973 135.288 174.088 136.116C176.203 136.944 178.513 136.898 180.593 135.984C182.674 135.075 184.276 133.407 185.104 131.293C185.932 129.178 185.885 126.869 184.975 124.79C184.066 122.71 182.398 121.109 180.282 120.281C179.279 119.888 178.233 119.694 177.187 119.694Z",
    fill: "url(#paint7_linear_4757_207265)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.686 135.067C152.757 135.067 150.828 134.705 148.978 133.982C145.082 132.459 142.01 129.512 140.334 125.68C138.654 121.847 138.572 117.595 140.093 113.7C141.617 109.806 144.564 106.735 148.398 105.06C152.232 103.381 156.486 103.299 160.382 104.819C164.278 106.342 167.35 109.289 169.026 113.121C170.706 116.954 170.787 121.206 169.267 125.101C167.743 128.995 164.795 132.066 160.961 133.741C158.951 134.628 156.82 135.067 154.686 135.067ZM154.678 110.898C153.519 110.898 152.364 111.139 151.268 111.617C149.188 112.526 147.586 114.194 146.757 116.308C145.929 118.423 145.976 120.732 146.886 122.811C147.796 124.891 149.464 126.492 151.579 127.32C153.694 128.148 156.004 128.101 158.084 127.192C160.164 126.282 161.766 124.615 162.595 122.5C163.423 120.386 163.376 118.077 162.466 115.998C161.556 113.918 159.888 112.317 157.773 111.489C156.774 111.092 155.724 110.898 154.678 110.898Z",
    fill: "url(#paint8_linear_4757_207265)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.36 187.513C185.928 187.513 185.485 187.435 185.057 187.268L124.567 163.628C122.723 162.909 121.818 160.833 122.537 158.991C123.256 157.148 125.333 156.243 127.176 156.962L187.666 180.602C189.509 181.321 190.415 183.397 189.696 185.239C189.144 186.646 187.791 187.513 186.36 187.513Z",
    fill: "url(#paint9_linear_4757_207265)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.89 206.606C178.455 206.606 178.015 206.528 177.588 206.361L117.097 182.72C115.254 182.001 114.348 179.926 115.067 178.083C115.787 176.241 117.863 175.335 119.706 176.054L180.197 199.695C182.04 200.414 182.946 202.489 182.227 204.332C181.674 205.743 180.321 206.606 178.89 206.606Z",
    fill: "url(#paint10_linear_4757_207265)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.082 227.785C232.65 227.785 232.207 227.708 231.779 227.54L190.723 211.491C188.879 210.772 187.974 208.697 188.693 206.854C189.412 205.012 191.489 204.102 193.332 204.825L234.388 220.87C236.232 221.59 237.138 223.665 236.418 225.508C235.866 226.922 234.513 227.785 233.082 227.785Z",
    fill: "url(#paint11_linear_4757_207265)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M263.57 93.4299C262.936 93.4299 262.299 93.2627 261.735 92.9246C239.039 79.3786 229.586 59.9246 225.651 45.99C221.401 30.9282 222.502 19.1198 222.548 18.6261C222.708 17.0286 223.909 15.7304 225.492 15.4544C240.995 12.7413 261.533 0.621907 261.739 0.501412C262.866 -0.167138 264.27 -0.167138 265.398 0.501412C265.604 0.621907 286.115 12.7452 301.594 15.4544C303.208 15.7381 304.421 17.0752 304.545 18.7077C304.584 19.2014 305.409 30.9243 301.03 45.9317C296.983 59.8158 287.522 79.2309 265.452 92.8935C264.881 93.2511 264.227 93.4299 263.57 93.4299ZM229.567 21.93C229.505 26.0074 229.804 34.4614 232.623 44.3109C237.662 61.9342 248.06 75.8221 263.539 85.6288C278.696 75.6783 288.996 61.6582 294.164 43.9261C296.998 34.201 297.453 25.9568 297.473 21.9144C290.96 20.4219 283.284 17.5766 274.609 13.4332C269.718 11.0972 265.752 8.93214 263.57 7.70387C261.385 8.93214 257.407 11.0972 252.508 13.4332C243.794 17.5883 236.091 20.4413 229.567 21.93Z",
    fill: "url(#paint12_linear_4757_207265)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.434 90.8721C261.459 90.8721 259.74 89.2707 259.74 87.2923V5.34438C259.74 3.36982 261.459 1.76453 263.434 1.76453C265.409 1.76453 267.128 3.36594 267.128 5.34438V87.2923C267.128 89.2668 265.409 90.8721 263.434 90.8721Z",
    fill: "url(#paint13_linear_4757_207265)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.78 61.5924H325.052C323.077 61.5924 321.471 59.8744 321.471 57.8998C321.471 55.9253 323.073 54.2073 325.052 54.2073H330.78C332.755 54.2073 334.361 55.9253 334.361 57.8998C334.357 59.8783 332.755 61.5924 330.78 61.5924Z",
    fill: "url(#paint14_linear_4757_207265)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.975 61.5924H346.532C344.556 61.5924 342.95 59.8744 342.95 57.8998C342.95 55.9253 344.552 54.2073 346.532 54.2073H352.975C354.95 54.2073 356.556 55.9253 356.556 57.8998C356.556 59.8783 354.95 61.5924 352.975 61.5924Z",
    fill: "url(#paint15_linear_4757_207265)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.673 75.4845C336.698 75.4845 335.174 73.8831 335.174 71.9046V66.1792C335.174 64.2047 336.698 62.5994 338.673 62.5994C340.648 62.5994 342.173 64.2008 342.173 66.1792V71.9046C342.173 73.8831 340.648 75.4845 338.673 75.4845Z",
    fill: "url(#paint16_linear_4757_207265)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M338.673 54.0129C336.698 54.0129 335.174 52.4115 335.174 50.4331V43.9924C335.174 42.0179 336.698 40.4126 338.673 40.4126C340.648 40.4126 342.173 42.014 342.173 43.9924V50.4331C342.173 52.4115 340.648 54.0129 338.673 54.0129Z",
    fill: "url(#paint17_linear_4757_207265)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30865 287.811H3.58115C1.60588 287.811 0 286.093 0 284.119C0 282.144 1.60199 280.426 3.58115 280.426H9.30865C11.2839 280.426 12.8898 282.144 12.8898 284.119C12.8859 286.097 11.2839 287.811 9.30865 287.811Z",
    fill: "url(#paint18_linear_4757_207265)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5031 287.811H25.0602C23.0849 287.811 21.479 286.093 21.479 284.119C21.479 282.144 23.081 280.426 25.0602 280.426H31.5031C33.4784 280.426 35.0843 282.144 35.0843 284.119C35.0843 286.097 33.4784 287.811 31.5031 287.811Z",
    fill: "url(#paint19_linear_4757_207265)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1086 301.649C15.1334 301.649 13.6091 300.048 13.6091 298.069V292.344C13.6091 290.369 15.1334 288.764 17.1086 288.764C19.0839 288.764 20.6081 290.365 20.6081 292.344V298.069C20.6081 300.048 19.0839 301.649 17.1086 301.649Z",
    fill: "url(#paint20_linear_4757_207265)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1086 280.177C15.1334 280.177 13.6091 278.576 13.6091 276.598V270.157C13.6091 268.182 15.1334 266.577 17.1086 266.577C19.0839 266.577 20.6081 268.179 20.6081 270.157V276.598C20.6081 278.576 19.0839 280.177 17.1086 280.177Z",
    fill: "url(#paint21_linear_4757_207265)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.777 378.376H112.05C110.075 378.376 108.469 376.658 108.469 374.684C108.469 372.709 110.071 370.991 112.05 370.991H117.777C119.753 370.991 121.359 372.709 121.359 374.684C121.359 376.658 119.753 378.376 117.777 378.376Z",
    fill: "url(#paint22_linear_4757_207265)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.972 378.376H133.529C131.554 378.376 129.948 376.658 129.948 374.684C129.948 372.709 131.55 370.991 133.529 370.991H139.972C141.947 370.991 143.553 372.709 143.553 374.684C143.553 376.658 141.951 378.376 139.972 378.376Z",
    fill: "url(#paint23_linear_4757_207265)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M125.593 392.187C123.617 392.187 122.093 390.585 122.093 388.607V382.881C122.093 380.907 123.617 379.302 125.593 379.302C127.568 379.302 129.092 380.903 129.092 382.881V388.607C129.092 390.585 127.568 392.187 125.593 392.187Z",
    fill: "url(#paint24_linear_4757_207265)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M125.593 370.715C123.617 370.715 122.093 369.114 122.093 367.135V360.695C122.093 358.72 123.617 357.115 125.593 357.115C127.568 357.115 129.092 358.716 129.092 360.695V367.135C129.092 369.114 127.568 370.715 125.593 370.715Z",
    fill: "url(#paint25_linear_4757_207265)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162.132 324.34C156.84 324.34 152.535 320.038 152.535 314.747C152.535 309.457 156.84 305.155 162.132 305.155C167.424 305.155 171.728 309.457 171.728 314.747C171.728 320.038 167.424 324.34 162.132 324.34ZM162.132 312.31C160.786 312.31 159.694 313.403 159.694 314.747C159.694 316.092 160.786 317.185 162.132 317.185C163.477 317.185 164.57 316.092 164.57 314.747C164.57 313.403 163.477 312.31 162.132 312.31Z",
    fill: "url(#paint26_linear_4757_207265)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.047 342.923H68.2051C61.9877 342.923 56.9329 337.866 56.9329 331.655V285.886C56.9329 279.671 61.9916 274.618 68.2051 274.618H121.044C127.261 274.618 132.316 279.675 132.316 285.886V331.651C132.32 337.866 127.261 342.923 121.047 342.923ZM68.2051 281.774C65.9382 281.774 64.0913 283.62 64.0913 285.886V331.651C64.0913 333.917 65.9382 335.763 68.2051 335.763H121.044C123.31 335.763 125.157 333.917 125.157 331.651V285.886C125.157 283.62 123.31 281.774 121.044 281.774H68.2051Z",
    fill: "url(#paint27_linear_4757_207265)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M115.409 281.692C113.434 281.692 111.828 280.091 111.828 278.112V261.461C111.828 251.977 104.11 244.261 94.6224 244.261C85.1349 244.261 77.4166 251.977 77.4166 261.461V278.112C77.4166 280.087 75.8146 281.692 73.8354 281.692C71.8602 281.692 70.2543 280.091 70.2543 278.112V261.461C70.2543 248.032 81.1844 237.105 94.6185 237.105C108.053 237.105 118.983 248.032 118.983 261.461V278.112C118.991 280.087 117.389 281.692 115.409 281.692Z",
    fill: "url(#paint28_linear_4757_207265)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.898 281.692C104.923 281.692 103.317 280.091 103.317 278.112V261.492C103.317 256.699 99.4168 252.805 94.6264 252.805C89.8321 252.805 85.936 256.703 85.936 261.492V278.112C85.936 280.087 84.334 281.692 82.3548 281.692C80.3796 281.692 78.7737 280.091 78.7737 278.112V261.492C78.7737 252.754 85.8854 245.645 94.6264 245.645C103.367 245.645 110.479 252.754 110.479 261.492V278.112C110.479 280.087 108.873 281.692 106.898 281.692Z",
    fill: "url(#paint29_linear_4757_207265)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5993 342.115C76.9927 342.115 76.3783 341.959 75.8145 341.636C74.0998 340.649 73.5321 338.461 74.5197 336.751L81.6548 324.402V295.075L74.3836 279.807C73.536 278.023 74.2864 275.889 76.075 275.038C77.8598 274.191 79.9906 274.949 80.8421 276.737L88.3777 292.735C88.6071 293.213 88.6577 293.738 88.6577 294.271V325.362C88.6577 325.988 88.5566 326.606 88.2416 327.15L80.6749 340.327C80.01 341.473 78.8357 342.115 77.5993 342.115Z",
    fill: "url(#paint30_linear_4757_207265)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M111.074 342.114C109.837 342.114 108.632 341.473 107.971 340.326L100.385 327.15C100.07 326.606 99.9299 325.988 99.9299 325.362V294.27C99.9299 293.738 100.023 293.213 100.253 292.731L107.866 276.733C108.718 274.948 110.844 274.191 112.633 275.042C114.418 275.893 115.118 278.027 114.266 279.811L106.929 295.079V324.402L114.115 336.747C115.102 338.457 114.542 340.645 112.831 341.636C112.268 341.963 111.68 342.114 111.074 342.114Z",
    fill: "url(#paint31_linear_4757_207265)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8432 303.747H61.2177C59.2425 303.747 57.6366 302.223 57.6366 300.249C57.6366 298.274 59.2386 296.75 61.2177 296.75H84.8432C86.8185 296.75 88.4244 298.274 88.4244 300.249C88.4244 302.227 86.8185 303.747 84.8432 303.747Z",
    fill: "url(#paint32_linear_4757_207265)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8431 313.464H61.2176C59.2424 313.464 57.6365 311.941 57.6365 309.966C57.6365 307.991 59.2385 306.468 61.2176 306.468H84.8431C86.8184 306.468 88.4242 307.991 88.4242 309.966C88.4242 311.944 86.8184 313.464 84.8431 313.464Z",
    fill: "url(#paint33_linear_4757_207265)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8431 323.57H61.2176C59.2424 323.57 57.6365 321.852 57.6365 319.878C57.6365 317.903 59.2385 316.185 61.2176 316.185H84.8431C86.8184 316.185 88.4242 317.903 88.4242 319.878C88.4242 321.856 86.8184 323.57 84.8431 323.57Z",
    fill: "url(#paint34_linear_4757_207265)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M128.159 303.747H104.176C102.201 303.747 100.595 302.223 100.595 300.249C100.595 298.274 102.197 296.75 104.176 296.75H128.159C130.135 296.75 131.74 298.274 131.74 300.249C131.74 302.227 130.135 303.747 128.159 303.747Z",
    fill: "url(#paint35_linear_4757_207265)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M128.159 313.464H104.176C102.201 313.464 100.595 311.941 100.595 309.966C100.595 307.991 102.197 306.468 104.176 306.468H128.159C130.135 306.468 131.74 307.991 131.74 309.966C131.74 311.944 130.135 313.464 128.159 313.464Z",
    fill: "url(#paint36_linear_4757_207265)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M128.159 323.57H104.176C102.201 323.57 100.595 321.852 100.595 319.878C100.595 317.903 102.197 316.185 104.176 316.185H128.159C130.135 316.185 131.74 317.903 131.74 319.878C131.74 321.856 130.135 323.57 128.159 323.57Z",
    fill: "url(#paint37_linear_4757_207265)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9126 264.804C45.5167 264.804 44.1908 263.984 43.6153 262.62C35.0027 242.26 30.6322 220.633 30.6322 198.346C30.6322 176.054 34.9988 154.431 43.6153 134.072C51.9363 114.408 63.8463 96.7495 79.0146 81.5866C94.183 66.4237 111.848 54.5181 131.519 46.2001C151.886 37.5906 173.52 33.2217 195.816 33.2217C197.791 33.2217 199.397 34.8231 199.397 36.8015C199.397 38.78 197.795 40.3814 195.816 40.3814C174.481 40.3814 153.787 44.5559 134.307 52.7923C115.491 60.7488 98.5885 72.1375 84.0734 86.6474C69.5582 101.157 58.1654 118.05 50.206 136.862C41.9706 156.328 37.7945 177.014 37.7945 198.342C37.7945 219.669 41.9706 240.356 50.2099 259.829C50.9798 261.648 50.1283 263.751 48.3085 264.521C47.8536 264.711 47.3792 264.804 46.9126 264.804Z",
    fill: "url(#paint38_linear_4757_207265)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M195.82 363.466C179.812 363.466 163.982 361.18 148.775 356.671C146.881 356.108 145.8 354.118 146.36 352.225C146.924 350.328 148.915 349.251 150.809 349.811C165.355 354.122 180.496 356.31 195.82 356.31C201.252 356.31 206.734 356.03 212.104 355.482C214.079 355.284 215.829 356.71 216.031 358.677C216.234 360.644 214.803 362.401 212.835 362.603C207.22 363.174 201.493 363.466 195.82 363.466Z",
    fill: "url(#paint39_linear_4757_207265)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M355.42 227.467C355.234 227.467 355.043 227.451 354.853 227.42C352.901 227.109 351.567 225.274 351.878 223.323C353.181 215.122 353.842 206.714 353.842 198.338C353.842 179.801 350.661 161.649 344.385 144.388C338.323 127.709 329.524 112.251 318.24 98.4442C318.178 98.3704 311.887 90.6937 306.338 85.2987C304.923 83.9188 304.891 81.6566 306.268 80.2379C307.648 78.823 309.915 78.7919 311.33 80.1679C317.175 85.8506 323.517 93.5856 323.785 93.9121C335.582 108.344 344.778 124.502 351.116 141.939C357.675 159.986 361 178.958 361 198.334C361 207.084 360.308 215.868 358.947 224.443C358.671 226.211 357.147 227.467 355.42 227.467Z",
    fill: "url(#paint40_linear_4757_207265)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4757_207265",
    x1: 43.9806,
    y1: -13.022,
    x2: 370.324,
    y2: 376.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4757_207265",
    x1: -171.71,
    y1: -2385.77,
    x2: 1759.09,
    y2: -1925.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4757_207265",
    x1: -341.013,
    y1: -1595.29,
    x2: 1874.9,
    y2: -625.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4757_207265",
    x1: -99.4412,
    y1: -4945.24,
    x2: 1820.41,
    y2: -4725.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4757_207265",
    x1: -361.145,
    y1: -2033.37,
    x2: 2083.39,
    y2: -1141.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4757_207265",
    x1: -30.1674,
    y1: -463.871,
    x2: 1021.23,
    y2: 58.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4757_207265",
    x1: 222.496,
    y1: -447.835,
    x2: 496.955,
    y2: -416.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4757_207265",
    x1: 3.65336,
    y1: -782.152,
    x2: 751.401,
    y2: -579.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4757_207265",
    x1: -18.8443,
    y1: -790.948,
    x2: 728.872,
    y2: -588.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4757_207265",
    x1: -218.475,
    y1: -722.77,
    x2: 1060.51,
    y2: 39.1703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4757_207265",
    x1: -225.944,
    y1: -703.677,
    x2: 1053.04,
    y2: 58.2636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4757_207265",
    x1: -54.4313,
    y1: -458.176,
    x2: 883.041,
    y2: 70.0546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4757_207265",
    x1: -191.877,
    y1: -2668.04,
    x2: 1801.2,
    y2: -2192.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4757_207265",
    x1: 222.528,
    y1: -2542.85,
    x2: 411.668,
    y2: -2538.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4757_207265",
    x1: 256.546,
    y1: -156.688,
    x2: 526.278,
    y2: -29.0113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4757_207265",
    x1: 274.421,
    y1: -156.688,
    x2: 553.301,
    y2: -17.3541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4757_207265",
    x1: 299.92,
    y1: -305.357,
    x2: 475.389,
    y2: -279.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4757_207265",
    x1: 299.92,
    y1: -347.967,
    x2: 475.771,
    y2: -323.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4757_207265",
    x1: -64.9255,
    y1: 69.531,
    x2: 204.807,
    y2: 197.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4757_207265",
    x1: -47.0502,
    y1: 69.531,
    x2: 231.83,
    y2: 208.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4757_207265",
    x1: -21.6445,
    y1: -79.1927,
    x2: 153.824,
    y2: -53.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4757_207265",
    x1: -21.6445,
    y1: -121.803,
    x2: 154.207,
    y2: -97.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4757_207265",
    x1: 43.5432,
    y1: 160.096,
    x2: 313.276,
    y2: 287.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4757_207265",
    x1: 61.4185,
    y1: 160.096,
    x2: 340.298,
    y2: 299.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4757_207265",
    x1: 86.8396,
    y1: 11.3449,
    x2: 262.308,
    y2: 37.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4757_207265",
    x1: 86.8396,
    y1: -31.265,
    x2: 262.691,
    y2: -6.72226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4757_207265",
    x1: 55.8618,
    y1: -242.728,
    x2: 513.774,
    y2: -118.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4757_207265",
    x1: -322.769,
    y1: -1675.94,
    x2: 1449.38,
    y2: -1145.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4757_207265",
    x1: -175.19,
    y1: -1036.15,
    x2: 972.179,
    y2: -696.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4757_207265",
    x1: -80.9255,
    y1: -783.745,
    x2: 687.476,
    y2: -600.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4757_207265",
    x1: 0.382105,
    y1: -1650.7,
    x2: 373.641,
    y2: -1628.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4757_207265",
    x1: 25.9011,
    y1: -1650.66,
    x2: 401.051,
    y2: -1628.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4757_207265",
    x1: -97.4404,
    y1: 96.9552,
    x2: 227.864,
    y2: 485.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4757_207265",
    x1: -97.4405,
    y1: 106.672,
    x2: 227.864,
    y2: 494.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4757_207265",
    x1: -97.4405,
    y1: 105.29,
    x2: 248.708,
    y2: 496.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4757_207265",
    x1: -56.2839,
    y1: 96.9552,
    x2: 268.343,
    y2: 488.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4757_207265",
    x1: -56.2839,
    y1: 106.672,
    x2: 268.343,
    y2: 498.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4757_207265",
    x1: -56.2839,
    y1: 105.29,
    x2: 289.353,
    y2: 500.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4757_207265",
    x1: -819.432,
    y1: -6580,
    x2: 3340.92,
    y2: -5757.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4757_207265",
    x1: -57.2792,
    y1: 71.8265,
    x2: 269.065,
    y2: 461.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4757_207265",
    x1: 24.4731,
    y1: -4156.1,
    x2: 1437.66,
    y2: -4012.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternOverlay);
export default __webpack_public_path__ + "static/media/pattern_overlay.c9b1b3da327e52077750a41fa58406b4.svg";
export { ForwardRef as ReactComponent };